import { t } from '@lingui/core/macro'

export const getSteps = () =>
  [
    {
      name: t`Setup`,
      slug: 'setup',
      description: t`Set Name, Description, and Folder`,
      previous: null,
      next: 'govern',
    },
    {
      name: t`Define and Govern`,
      slug: 'govern',
      description: t`Add and Customize Fields`,
      previous: 'setup',
      next: 'connect',
    },
    {
      name: t`Connect`,
      slug: 'connect',
      description: t`Integrate with your Ecosystem`,
      previous: 'govern',
      next: null,
    },
  ] as const

export const stepNameIdx = {
  setup: 0,
  govern: 1,
  connect: 2,
} as const
